/* eslint "dot-notation": "off" */
export const pageView = url => {
  window['dataLayer'] = window['dataLayer'] || [];
  window['dataLayer'].push({
    event: 'pageview',
    page: url,
  });
};
